var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureImage4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 54,
    viewBox: "0 0 43 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3033 53.7564C17.0073 53.6044 14.4309 52.1998 12.6876 49.3463C12.4221 48.9134 12.399 48.6902 12.9666 48.4208C15.0158 47.4491 15.9432 45.7924 15.6662 43.5181C15.5719 42.7504 16.1299 43.1698 16.3473 43.1679C18.7602 43.1506 20.6574 41.5824 21.0749 39.2138C21.1961 38.5308 22.1563 37.5437 22.8316 37.3801C24.5133 36.9722 25.7294 35.9794 26.2335 34.3188C26.753 32.6063 26.4509 30.9978 25.1117 29.7202C19.1065 23.9959 13.0936 18.2793 7.06722 12.5761C6.03204 11.5968 5.28548 10.5231 5.66646 9.03382C6.2995 6.55554 9.14529 5.73394 11.054 7.49452C13.4322 9.68803 15.7643 11.9335 18.1156 14.1559C20.49 16.4013 22.8605 18.6487 25.2329 20.8942C25.9583 21.5811 26.7472 22.1795 27.6727 22.572C29.5411 23.3647 30.9188 23.0684 32.206 21.4906C33.5644 19.8224 34.4707 17.856 35.6271 16.055C37.2414 13.544 40.9088 13.6036 42.3192 16.1916C43.0273 17.4923 43.0023 18.8392 42.2326 20.1245C40.1469 23.613 38.0784 27.113 35.9253 30.561C35.3924 31.4134 35.4212 32.058 35.8503 32.9161C36.7643 34.7421 37.8245 36.5123 38.3055 38.5269C39.1887 42.2289 37.4281 46.362 34.057 48.0995C30.6455 49.8562 27.1609 51.4744 23.6821 53.0926C22.6373 53.5755 21.4944 53.8237 20.3033 53.7564Z",
    fill: "url(#paint0_linear_1469_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21878 26.5748C8.06732 26.5151 8.80427 26.875 9.42961 27.4618C12.5101 30.3499 15.5868 33.2419 18.6481 36.1493C20.0681 37.4981 20.1528 39.4126 18.904 40.7787C17.6861 42.1102 15.683 42.166 14.2746 40.8518C11.1652 37.9522 8.07117 35.0333 4.98679 32.1067C3.97085 31.1427 3.71109 29.7477 4.23638 28.497C4.74435 27.2906 5.84111 26.5748 7.21878 26.5748Z",
    fill: "url(#paint1_linear_1469_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39146 24.4081C9.44149 22.6879 10.0803 21.7278 11.2963 21.1679C12.6125 20.5618 13.817 20.8446 14.8368 21.7971C17.621 24.3966 20.3744 27.0268 23.1394 29.6475C23.4646 29.9554 23.7917 30.2632 24.1053 30.5826C25.4426 31.9449 25.5003 33.8363 24.2477 35.139C22.997 36.4416 20.992 36.4743 19.5913 35.1659C17.2304 32.957 14.8964 30.7212 12.5509 28.4969C11.8774 27.8581 11.2001 27.2231 10.5228 26.5862C9.79168 25.8954 9.34913 25.0777 9.39146 24.4081Z",
    fill: "url(#paint2_linear_1469_5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0307 47.4479C10.2322 47.496 9.50876 47.1112 8.88534 46.5224C6.28007 44.0653 3.67094 41.6101 1.09068 39.128C-0.310083 37.7811 -0.356262 35.8281 0.92136 34.4966C2.18359 33.1824 4.12696 33.1728 5.55274 34.5081C8.14262 36.9345 10.7229 39.3723 13.2954 41.8179C14.3787 42.8473 14.6654 44.098 14.1555 45.4988C13.7207 46.6917 12.4989 47.4518 11.0307 47.4479Z",
    fill: "url(#paint3_linear_1469_5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.153 5.89193C26.1568 6.62887 25.6488 7.31194 24.9581 7.31386C24.1942 7.31771 23.6708 6.90402 23.5746 6.12283C23.3822 4.56813 23.2148 3.00958 23.0763 1.44911C23.007 0.68331 23.3399 0.117615 24.1538 0.0156362C24.9908 -0.0882669 25.5199 0.329269 25.6258 1.16049C25.822 2.71519 25.974 4.27566 26.153 5.89193Z",
    fill: "url(#paint4_linear_1469_5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1885 8.18565C28.2861 8.1818 27.6858 7.43331 28.0263 6.54821C28.6324 4.97427 29.3116 3.42535 30.0524 1.91106C30.3353 1.33382 30.9491 1.09715 31.6187 1.38577C32.2729 1.66669 32.5596 2.22277 32.3479 2.86543C31.8015 4.53172 31.0164 6.10374 30.2583 7.68153C30.0582 8.09521 29.6195 8.16833 29.1885 8.18565Z",
    fill: "url(#paint5_linear_1469_5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9123 7.40202C21.8835 7.96387 21.6237 8.37371 21.0927 8.58151C20.5173 8.80664 19.9805 8.67195 19.6245 8.20246C18.6394 6.90752 17.6773 5.59526 16.7557 4.25222C16.3131 3.60764 16.4324 2.92842 17.0962 2.49356C17.6889 2.10681 18.3565 2.14145 18.8145 2.73408C19.7881 3.99823 20.7175 5.29702 21.6507 6.59196C21.8181 6.82286 21.9297 7.09801 21.9123 7.40202Z",
    fill: "url(#paint6_linear_1469_5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5458 11.2081C31.982 11.1543 31.5914 10.9349 31.3586 10.452C31.0988 9.91705 31.1893 9.38022 31.6068 9.05119C32.9864 7.96598 34.391 6.90386 35.8476 5.9264C36.3575 5.58391 36.9732 5.79172 37.3792 6.31893C37.7813 6.84422 37.8429 7.4811 37.3619 7.89094C35.9823 9.07428 34.5161 10.1556 32.9595 11.1042C32.8306 11.1812 32.6555 11.1812 32.5458 11.2081Z",
    fill: "url(#paint7_linear_1469_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1469_5",
    x1: 8.81976,
    y1: 15.3964,
    x2: 55.5008,
    y2: 55.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1469_5",
    x1: 5.35228,
    y1: 29.4226,
    x2: 20.4418,
    y2: 46.6301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1469_5",
    x1: 10.765,
    y1: 23.711,
    x2: 25.909,
    y2: 40.8785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1469_5",
    x1: 1.25756,
    y1: 36.1202,
    x2: 15.0712,
    y2: 51.8031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1469_5",
    x1: 23.3368,
    y1: 1.36982,
    x2: 28.9127,
    y2: 3.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1469_5",
    x1: 28.3215,
    y1: 2.5593,
    x2: 34.8564,
    y2: 7.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1469_5",
    x1: 16.9666,
    y1: 3.44703,
    x2: 23.3868,
    y2: 9.37992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1469_5",
    x1: 31.7796,
    y1: 6.7794,
    x2: 37.0303,
    y2: 13.6527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1F25",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImage4);
export default __webpack_public_path__ + "static/media/FeatureImage4.546daba1d163954170214552a48f4a5a.svg";
export { ForwardRef as ReactComponent };